import React from 'react';
import ReactDOM from 'react-dom';
import { Card, Affix, Button, Spin } from 'antd';
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
import { uuid, copy, copyArr } from 'rt-sd-common/sgiCommon/sgiCommon'
import style from './SgiPanel.css';
// import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { AllCompGUID } from 'rt-sd-common/sgiConstants/SgiCompConstant';
// const TabPane = Tabs.TabPane;
// const Panel = Collapse.Panel;

class SgiPanel extends React.Component {

    //这个暂时不好用 以后在处理
    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            //ctnProps: { style: {} },//form属性
            panelProps: { style: { heigth: '100%', width: '100%' } },//panel全局属性
            panelTitleProps: { style: {} },//panel的title属性
            panelBodyProps: { style: {} },//panel的body属性
            cardProps: { headStyle: {}, bodyStyle: {} },//card属性
            spinProps: { style: {} },//加载框属性
            panelItems: [], //面板下控件数组loading
            loading: false,
            toolbarTopItems: [],
            toolbarBottomItems: [],
            panelUUID: undefined,
            isCard: false,
            title: null
        };
    }

    /**
     * 根据描述创建form
     * @param {父组件} parentModule 
     * @param {描述} moduleDesc       
     * @param {对象工厂} objFct 
     * @param {make类型} type 
     */
    panel_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.panelItems = []; //再次渲染的时候清空

        //转换form公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.panelProps, this.state.spinProps);
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.panelProps, this.state.panelTitleProps, this.state.panelBodyProps, this.state.cardProps, parentModule);
        //设置布局
        //this.setFormCtlLayout(moduleDesc, formProps);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.panelProps);
        //组装form表单下的控件信息
        if (type !== "dnd") this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, type);
        //组装自定义form下ucv，且重新创建objFct
        this.fitUCVNEWObjectItems(moduleDesc, this.state.panelItems, objFct, type);
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc 
     * @param {*} formProps 
     */
    bindEvent(moduleDesc, formProps) {

    }

    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc 
     * @param {属性} formProps 
     */
    fitPanelItems = function (moduleDesc, panelItems, objFct, type) {
        this.state.extras = [];
        var me = this;
        //form下的子节点添加到form组件中
        let cldSet = moduleDesc.cldSet;
        if (cldSet && cldSet.length && cldSet.length > 0) {
            cldSet.forEach((item, index) => {
                if (item.desId === AllCompGUID.TOOLBAR) {
                    if (item.inTitle) {
                        this.state.btnAlg = item.btnAlg || "right";//记录按钮位置
                        // const itemSons = item.cldSet;
                        // if (itemSons) {
                        //     itemSons.forEach(son => {
                        //         this.state.extras.push(convertModuleByGuid(this, son, null, objFct, type));
                        //     });
                        // }
                        this.state.extras.push(convertModuleByGuid(this, item, null, objFct, type));
                    } else {
                        if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
                            this.state.toolbarTopItems.push(convertModuleByGuid(this, item, null, objFct, type));
                        } else {
                            this.state.toolbarBottomItems.push(convertModuleByGuid(this, item, null, objFct, type));
                        }
                    }
                } else {
                    panelItems.push(convertModuleByGuid(me, item, null, objFct, type));
                }
            });
        }
    }

    fitUCVNEWObjectItems(moduleDesc, panelItems, objFct, type) {
        var me = this;
        const customCldSet = moduleDesc.customCldSet;
        if (customCldSet && customCldSet.length > 0) {
            customCldSet.forEach(element => {
                //重新创建 对象工厂
                const newObjFct = new ObjFactory(element.guid + "@@" + uuid(6), element.transferData);
                panelItems.push(convertModuleByGuid(me, element, null, newObjFct, type));
            });
        }
    }

    refresh = () => {
        this.loaded = false;
        this.state.panelUUID = uuid(8);
        this.setState({});
    }

    getChildContent(type, overflow) {
        const { loading } = this.state;
        let spinProps = this.state.spinProps;
        if (typeof loading === "object") {
            Object.assign(spinProps, loading);
        } else {
            spinProps.spinning = loading;
        }
        if (type === "dnd") spinProps.spinning = false;
        return (
            // <Spin wrapperClassName="sgiSpin" {...spinProps}>
            <Spin wrapperClassName={`sgiSpin ${overflow ? "_overflow" : null}`} {...spinProps}>
                <div key={this.state.panelUUID} className={style.body} {...this.state.panelBodyProps}>
                    {this.state.panelItems}
                    {this.props.children}
                    {this.state.customCldSet}
                </div>
            </Spin >
        );
    }

    getTitle() {

        // 自定义title
        if (this.state.title || this.state.title == "") {
            return this.state.title;
        }

        // 通常title
        const isTtl = this.state.isTtl;
        const titleText = this.state.panelTitleProps.title;
        const btnAlg = this.state.btnAlg;
        if (btnAlg === "left") {
            return <div style={{ lineHeight: 0 }}>
                {isTtl ? <span style={{ marginRight: "10px" }}>{titleText}</span> : null}
                {this.state.extras}</div>
        } else {
            return isTtl ? titleText : null;
        }
    }

    // 外部接口
    setTitle(title) {
        this.setState({ title });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性
            this.panel_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        // 通用渲染前处理，添加自定义样式等
        this.renderBeforeReturn(this.state.panelProps);
        // // 自定义样式处理
        // const getCstmStyle = this.state.cstmStyle;
        // let cstmStyle = {};
        // if (getCstmStyle/* && type !== "dnd"*/) {
        //     cstmStyle = getCstmStyle(this, objFct) || {};
        // }
        // Object.assign(this.state.panelProps.style, cstmStyle);

        return (
            <div className={style.panel} {...this.state.panelProps}>
                {this.state.toolbarTopItems ? this.state.toolbarTopItems : null}
                {this.state.isCard ?
                    <Card title={this.getTitle()}
                        className="sgiCard"
                        // bordered={!!this.state.panelProps.style.border}
                        bordered={false}
                        size="small"
                        extra={this.state.btnAlg === "left" ? null : this.state.extras}
                        {...this.state.cardProps}>
                        {this.getChildContent(type, false)}
                    </Card>
                    :
                    <div style={{ flex: 1, height: '100%', width: '100%', display: 'inherit', 'flex-direction': 'inherit' }}>
                        <div className={style.title} {...this.state.panelTitleProps}>
                            <span>{this.state.panelTitleProps.title}</span>
                        </div>
                        {this.getChildContent(type, this.state.spinProps.style.overflow)}
                    </div>
                }
                {this.state.toolbarBottomItems ? this.state.toolbarBottomItems : null}
            </div >
        )
    }



    /**
     * 属性转换
     * @param {描述信息} moduleDesc 
     * @param {属性} panelProps 
     */
    AddAttribute = function (moduleDesc, panelProps, panelTitleProps, panelBodyProps, cardProps, parentModule) {
        var type;
        if (parentModule && parentModule.state && parentModule.state.itemPanelType) {
            type = parentModule.state.itemPanelType;
        }

        var text = panelProps.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
        if (text) panelTitleProps.title = text;

        var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
        if (ttlAlgn) panelTitleProps.style['text-align'] = ttlAlgn;

        var isTtl = moduleDesc.isTtl; //form是否显示标题
        if (!isTtl) {
            panelTitleProps.style.display = "none";
        } else {
            panelTitleProps.style.display = undefined;
        }
        this.state.isTtl = !!isTtl;

        // 是否card样式
        const isCard = moduleDesc.isCard;
        this.state.isCard = !!isCard;

        if (type === 'tabs' || type == 'cos') {
            panelTitleProps.style.display = "none";
        }

        // body样式
        panelBodyProps.style.margin = moduleDesc.bdMgn; //body外边距
        panelBodyProps.style.padding = moduleDesc.bdPad || "5px 10px"; //body内边距 //保持原有样式，默认5px 10px

        // card样式
        cardProps.headStyle.width = moduleDesc.cardHeadW; //card header宽度
        cardProps.headStyle.height = moduleDesc.cardHeadH; //card header高度//保持原有样式，默认100%

        var isScl = moduleDesc.isScl; //是否滚动
        if (isScl) {
            cardProps.bodyStyle.overflow = "auto";
            // cardProps.headStyle.height = cardProps.headStyle.height || 0;
        } else {
            cardProps.bodyStyle.overflow = undefined;
        }

        var icon = moduleDesc.icon; //form背景图片??没实现        
        var bdsty = moduleDesc.bdsty; //form背景颜色??没实现        
        var ttlAlg = moduleDesc.ttlAlg; //form标题位置??没实现
        var isCls = moduleDesc.isCls; //form是否可以关闭??没实现
        var isFrm = moduleDesc.isFrm; //form是否填充??没实现-----del     
        var html = moduleDesc.html; //form显示html元素??没实现     
        var isDis = moduleDesc.isDis; //form是否禁用??没实现 
        var csstyle = moduleDesc.csstyle; //form样式??没实现
        var flx = moduleDesc.flx; //form占比??没实      
    }

    componentDidMount() {
        const { didMountCallback, objFct } = this.props;
        // 自定义渲染后事件
        if (didMountCallback && typeof didMountCallback === "function") {
            didMountCallback(this, objFct);
        }
    }

}
//给类添加公共方法
Object.assign(SgiPanel.prototype, sgiCtnBaseFun);
export { SgiPanel };
export default SgiPanel;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiPanel.js